import {Steps} from 'antd';
import Blocknative from 'bnc-sdk';
import {useEffect, useState} from 'react';
import {BLOCKNATIVE_DAPPID, NETWORK} from 'src/constants';

const {Step} = Steps;

const notify = new Blocknative({
  dappId: BLOCKNATIVE_DAPPID,
  networkId: NETWORK.chainId,
});

enum State {
  Start,
  Sent,
  Pool,
  Confirmed,
  Cancel,
  Failed,
}

const StepNumber = {
  [State.Start]: 0,
  [State.Sent]: 0,
  [State.Pool]: 1,
  [State.Confirmed]: 2,
  [State.Cancel]: 2,
  [State.Failed]: 2,
};

function getStatus(state: State) {
  if ([State.Start, State.Sent].includes(state)) {
    return 'wait';
  } else if (state === State.Pool) {
    return 'process';
  } else if (state === State.Confirmed) {
    return 'finish';
  } else {
    return 'error';
  }
}
export default function TransactionStatus(props: {hash: string}) {
  const [state, setState] = useState<State>(State.Start);

  useEffect(() => {
    const {emitter} = notify.transaction(props.hash);

    emitter.on('txSent', () => setState(State.Sent));
    emitter.on('txPool', () => setState(State.Pool));
    emitter.on('txConfirmed', (t) => setState(State.Confirmed));
    emitter.on('txCancel', () => setState(State.Cancel));
    emitter.on('txFailed', () => setState(State.Failed));

    return () => {
      notify.unsubscribe(props.hash);
    };
  }, [props.hash]);

  return (
    <Steps current={StepNumber[state]} status={getStatus(state)}>
      <Step title='Start' description='Transaction sent' />
      <Step title='Processing' description='In pool' />
      <Step
        title={getStatus(state) === 'error' ? 'Failed' : 'Completed'}
        description={getStatus(state) === 'error' ? 'Transaction failed' : 'Transaction succeeded!'}
      />
    </Steps>
  );
}
